import { useEffect, useState, useCallback } from 'react';
import progressQueue from '../lib/progressQueue';
import { useAuth } from '../context/AuthContext';

export function useProgressQueue() {
  const [queue, setQueue] = useState(() => progressQueue.listQueue());
  const [processing, setProcessing] = useState(false);

  const { isAuthenticated } = useAuth();

  useEffect(() => {
    let updater = null;

    const start = () => {
      progressQueue.startQueueProcessor();
      // refresh queue listing every 2s while active
      updater = setInterval(() => setQueue(progressQueue.listQueue()), 2000);
    };

    const stop = () => {
      if (updater) { clearInterval(updater); updater = null; }
      progressQueue.stopQueueProcessor();
    };

    const handleVisibility = () => {
      if (document.hidden || !isAuthenticated) {
        stop();
      } else {
        // visible + authenticated
        setQueue(progressQueue.listQueue());
        start();
      }
    };

    // start only if authenticated and visible
    handleVisibility();

    document.addEventListener && document.addEventListener('visibilitychange', handleVisibility);

    return () => {
      stop();
      document.removeEventListener && document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, [isAuthenticated]);

  const enqueue = useCallback((update) => {
    const item = progressQueue.enqueue(update);
    setQueue(progressQueue.listQueue());
    return item;
  }, []);

  return {
    queue,
    enqueue,
    processing
  };
}

export default useProgressQueue;
